import React from "react";
import { map, isEmpty, find } from "lodash";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import FontIcon from "react-md/lib/FontIcons";

import {
    humanFormatDate,
    humanFormatHoursMinutes,
    formatTime,
    minutesToDaysHoursMinutesString,
    humanFormatPrice
} from "../../utils/index";
import {DebugElement} from "../../Atollon/debug";
import {TouchVerticalValue, TouchVerticalValue_2} from "../../AtollonTheme/ReactElements";
import {requestStatusBackgroundColor, requestStatusColorInfoFromRequestStatus} from "../../enums/index";


let comment = () =>
{

};

const canShowStatus = ( c ) =>
{
    if( c.changes )
    {
        return find(
            c.changes,
            ch =>
                ch.fieldName === "status" || ch.fieldName === "pendingSide"
        );
    }
    else
    {
        return false;
    }
};

const getStatusCSSClassName = ( c ) =>
{
    if( c.changes )
    {
        const found = find(c.changes, ch => ch.fieldName === "status");
        if( found )
        {
            const statusSymbolicName = found.newValue;
            const info = requestStatusColorInfoFromRequestStatus( statusSymbolicName );
            const className = ` ${info.backgroundClassName} ${info.backgroundColor_pairedFontColor} `;
            return className;
        }
        else
        {
            return '';
        }

    }
    else
    {
        return '';
    }
};

const getStatus = ( c, status ) =>
{
    return (
    find(c.changes, ch => ch.fieldName === "status")
        ? `Požadavek ${find(
            c.changes,
            ch => ch.fieldName === "status"
        ).newValue === "CLOSED"
            ? "uzavřen"
            : find(c.changes, ch => ch.fieldName === "status")
                .newValue === "ACCEPTED"
                ? "přijatý"
                : find(c.changes, ch => ch.fieldName === "status")
                    .newValue === "DISMISSED"
                    ? "zrušen"
                    : find(
                        c.changes,
                        ch => ch.fieldName === "status"
                    ).newValue === "RESOLVING"
                        ? "vyřešený"
                        : ""} ${formatTime(
            c.created
        )} uživatelem ${c.madeByName} (${c.madeBy})`
        : find(
            c.changes,
            ch => ch.fieldName === "pendingSide"
        ) &&
        find(c.changes, ch => ch.fieldName === "pendingSide")
            .newValue === "SENDER"
            ? status === "INITIAL"
                ? `Požadavek byl ${formatTime(
                    c.created
                )} vrácen zasílateli.`
                : status === "ACCEPTED"
                    ? `Požadavek byl odložen ${formatTime(
                        c.created
                    )} a čeká na zasílatele.`
                    : ""
            : ""
    );
};


const getChanges = ( c, priceCurrency ) =>
{

    const getChangeOrEmptyString = ( item, priceCurrency ) =>
    {
        return (
            item.fieldName === "project" ? (
                !item.value ? (
                    <span>
                                                            Projekt '<strong>{item.newValueName}</strong>' byl
                                                            přiřazen.
                                                          </span>
                ) : !item.newValueName ? (
                    <span>Projekt byl odebrán.</span>
                ) : (
                    <span>
                                                            Projekt byl změněn z '<strong>{item.valueName}</strong>'
                                                            na '<strong>{item.newValueName}</strong>'.
                                                          </span>
                )
            ) : item.fieldName === "priceAmount" ? (
                !item.value ? (
                    <span>
                                                            Cena{" "}
                        <strong>
                            {humanFormatPrice( item.newValueName, priceCurrency )}
                                                            </strong>{" "}
                        byla přiřazena.
                                                          </span>
                ) : (
                    <span>
                                                            Cena byla změněna z{" "}
                        <strong>
                            {humanFormatPrice( item.valueName, priceCurrency )}
                                                            </strong>{" "}
                        na{" "}
                        <strong>
                            {humanFormatPrice( item.newValueName, priceCurrency )}
                                                            </strong>.
                                                          </span>
                )
            ) : item.fieldName === "priceTaxAmount" ? (
                !item.value ? (
                    <span>
                                                            Daň{" "}
                        <strong>
                            {humanFormatPrice( item.newValueName, priceCurrency )}
                                                            </strong>{" "}
                        byla přiřazena.
                                                          </span>
                ) : (
                    <span>
                                                            Daň se změnila z{" "}
                        <strong>
                            {humanFormatPrice( item.valueName, priceCurrency )}
                                                            </strong>{" "}
                        na{" "}
                        <strong>
                            {humanFormatPrice( item.newValueName, priceCurrency )}
                                                            </strong>.
                                                          </span>
                )
            ) : item.fieldName === "severity" ? (
                !item.value ? (
                    <span>
                                                            Vážnost <strong>{item.newValueName}</strong> byla
                                                            přiřazena.
                                                          </span>
                ) : (
                    <span>
                                                            Vážnost požadavku se{" "}
                        {item.newValueName > item.valueName
                            ? "zvýšila"
                            : "snížila"}{" "}
                        z <strong>{item.valueName}</strong> na{" "}
                        <strong>{item.newValueName}</strong>.
                                                          </span>
                )
            ) : item.fieldName === "customType" ? (
                !item.value ? (
                    <span>
                                                            Typ požadavku '<strong>{item.newValueName}</strong>'
                                                            byl přiřazena.
                                                          </span>
                ) : (
                    <span>
                                                            Typ požadavku se změnil z '<strong>{item.valueName}</strong>'
                                                            na '<strong>{item.newValueName}</strong>'.
                                                          </span>
                )
            ) : item.fieldName === "estimatedDuration" ? (
                !item.value ? (
                    <span>
                                                            Odhadované trvání bylo nastaveno na{" "}
                        <strong>
                                                              {minutesToDaysHoursMinutesString(
                                                                  item.newValueName,
                                                                  true
                                                              )}
                                                            </strong>.
                                                          </span>
                ) : (
                    <span>
                                                            Odhadované trvání bylo změněno z{" "}
                        <strong>
                                                              {minutesToDaysHoursMinutesString(
                                                                  item.valueName,
                                                                  true
                                                              )}
                                                            </strong>{" "}
                        na{" "}
                        <strong>
                                                              {minutesToDaysHoursMinutesString(
                                                                  item.newValueName,
                                                                  true
                                                              )}
                                                            </strong>.
                                                          </span>
                )
            ) : (
                ""
            )
        );
    };
    let countOfNonEmptyValues = 0;
    const returnReact = (
            <TouchVerticalValue_2
                title={"Změny v parametrech požadavku:"}
                value={
                    <div className={"touchRequestDetail-greybox touchRequestDetail-greybox--withBorder"}>
                            {c.changes &&
                                map(c.changes, (item, k) => {
                                    const itemReact = getChangeOrEmptyString( item, priceCurrency );
                                    if( itemReact )
                                    {
                                        countOfNonEmptyValues++;
                                        return (
                                            <div key={k} style={{margin: '8px 0'}}>
                                                {itemReact}
                                            </div>
                                        );
                                    }
                                    else
                                    {
                                        return null;
                                    }
                                })
                            }
                    </div>

                }
                value2={null}
            />
    );

    return ( countOfNonEmptyValues > 0 ? returnReact: null );
};

const RequestDetailComments = ( { history, comments, priceCurrency, status }) => {



    const attachments = null;

    return (
    <div className="flex-col comments">
      <DebugElement text={"src/components/request/Comments.js "}/>

        {/*

      {map(comments, (c, i) => (

          <TouchVerticalValue
              icon={null}
              title={"Datum:"}
              value={listingValues.sender}
              value2={null}
          />

          <TouchVerticalValue
              icon={null}
              title={"Od koho:"}
              value={listingValues.sender}
              value2={null}
              onClick={() => {
                  if (sender === user.identifier) history.push("/");
                  else history.push(`/person/${sender}`);
              }}
          />

          <TouchVerticalValue
          icon={null}
          title={"Od koho:"}
          value={listingValues.sender}
          value2={null}
          />

      )}

      */}

        {map(comments, (c, i) => {
            const someUniqueKey = i;
            return (
            <div key={someUniqueKey} className={"touchRequestDetail-comment"}>

                {canShowStatus( c ) ?
                    <div className={`touchRequestDetail-commentStatus ${getStatusCSSClassName( c )}`}>{getStatus( c )}</div>
                    : null
                }

                <div className={"touchRequestDetail-commentHeader"} >
                    <div className="touchRequestDetail-commentHeader-spaceAround">

                            <div className={"touchRequestDetail-commentHeaderItemBorder"}>
                                <div className={"touchRequestDetail-commentHeaderItem"}>
                                    <TouchVerticalValue_2
                                        title={"Datum:"}
                                        value={(
                                            <div>
                                                <div>{humanFormatDate(c.created)}</div>
                                                <div>{humanFormatHoursMinutes(c.created)}</div>
                                            </div>
                                        )}
                                    />
                                </div>
                            </div>

                            <div className={"touchRequestDetail-commentHeaderItem"}>
                                <TouchVerticalValue_2
                                    title={"Od koho:"}
                                    value={<div><div>{c.madeByName}</div><div className={"link"}>{c.madeBy}</div></div>}
                                />
                            </div>
                    </div>
                </div>


                <div className="touchRequestDetail-comment-layout-commentTextAndIconsSpaceAround">
                    <div className="touchRequestDetail-comment-layout-commentTextAndIcons">
                        <div className="touchRequestDetail-comment-layout-commentTextAndIcons-1">
                        {c.comment ?
                            <div className="touchRequestDetail-text">
                                {c.comment}
                            </div>
                            : null
                        }
                        </div>
                        <div className="touchRequestDetail-comment-layout-commentTextAndIcons-2">

                            {attachments}

                            {getChanges( c, priceCurrency )}

                        </div>
                    </div>
                </div>



            </div>
      )})}
    </div>
  );
};

export default RequestDetailComments;



// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestDetailComments.js